import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GuidService {
  private readonly guidKey = 'client_guid';

  constructor() {
    // Ao iniciar o serviço, verificamos se já existe o GUID
    this.checkAndSetGuid();
  }

  // Função para gerar o GUID
  private generateGUID(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  // Função que verifica e gera o GUID, se necessário
  private checkAndSetGuid(): void {
    const existingGuid = localStorage.getItem(this.guidKey);
    if (!existingGuid) {
      const newGuid = this.generateGUID();
      localStorage.setItem(this.guidKey, newGuid);
    }
  }

  // Função para obter o GUID
  getGuid(): string | null {
    return localStorage.getItem(this.guidKey);
  }
}
